import getPostBySlug from '../api/graphql/queries/getPostBySlug';

const checkPostSlugNameRepeated = async (slug) => {
  let slugNameRepeated;

  await getPostBySlug(slug).then((res) => {
    if (res.post !== null) {
      console.log('slugName already taken');
      slugNameRepeated = true;
    } else {
      console.log('available slugName');
      slugNameRepeated = false;
    }
  }).catch(err => console.log(err));
  return slugNameRepeated;
};

export default checkPostSlugNameRepeated;
